import BaseService from "./geral/BaseService";
import {objetoParaQueryString} from "../utils/formatar";
import {http} from "../config/Constantes";
import lscache from "lscache";

const base = "AnaliseCritica";

export default class AnaliseCriticaService extends BaseService {
    constructor() {
        super(base);
    };

    listar(filtros){
        let str = objetoParaQueryString(filtros);
        return super.httpGet(`/${base}/ListarAnalises?${str}`);
    };

    listarStatus(){
        return super.httpGet(`/${base}/ListarStatus`);
    };

    listarParceirosPorRadical(radical){
        return super.httpGet(`/${base}/ListarParceirosPorRadical/${radical}`);
    };

    listarParceirosPorRadicalOuCgc(radical){
        return super.httpGet(`/${base}/ListarParceirosPorRadicalOuCgc/${radical}`);
    }

    listarEmbalagem(){
        return super.httpGet(`/${base}/ListarEmbalagem`);
    };

    listarParceirosRelacionados(analiCritId){
        return super.httpGet(`/${base}/ListarParceirosRelacionados/${analiCritId}`);
    };

    listarTiposMercadoria(){
        return super.httpGet(`/${base}/ListarTipoProduto`)
    }

    obterAnalise(analiCritId){
        return super.httpGet(`/${base}/ObterAnalise/${analiCritId}`);
    }

    carregarPorNcm(ncm){
        return super.httpGet(`/${base}/CarregarPorNcm?ncm=${ncm}`);
    };

    carregarParceiroPorCNPJ(cnpj){
        return super.httpGet(`/${base}/CarregarParceiroPorCNPJ/${cnpj}`);
    };

    enviarAnalise(analiseCritId){
        return super.httpGet(`/${base}/EnviarAnalise/${analiseCritId}`);
        //return Promise.resolve({data:{}});
    };

    downloadAnexo(anexoId){
        return http.get(`/${base}/DownloadAnexo/${anexoId}`, {
            responseType: 'blob', headers: { Authorization: lscache.get('access_token') }
        }).then(function (response) {
            return response;
        }).catch((error) => {
            if(error.response.status === 401) {
                lscache.flush();
                lscache.set("errorMessage","Senha expirada, acesse a opção 'esqueci minha senha'.")                
                window.location.replace("/login")
            }
        });
    };

    deletarAnexo(anexoId){
        return super.httpGet(`/${base}/DeletarAnexo/${anexoId}`);
    };

    persistirAnalise (analise) {
        return super.httpPost(`/${base}/PersistirAnalise`, analise);
    };

    salvarAnexo(anexo, extensao, dscArquivo, analiseCriticaId) {
        return super.httpPost(`/${base}/SalvarAnexo?extensao=${extensao}&dscArquivo=${dscArquivo}&analiseCriticaId=${analiseCriticaId}`, anexo)
    };
}


// WEBPACK FOOTER //
// ./src/services/AnaliseCriticaService.js